import client from './client';
import qs from 'qs';

const carUrl = '/api/v1/car';

//차량 예약 내역 리스트
export const getCarReservList = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${carUrl}/usage/reserv?${queryString}`);
};

export const getCarReservPcList = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${carUrl}/usage/reservPc?${queryString}`);
};

//차량 신청 내역 리스트
export const getCarUsageList = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${carUrl}/usage/history?${queryString}`);
};

//차량 방문 리스트
export const getCarUsageVisitList = (searchData) => {
  const queryString = qs.stringify(searchData);
  return client.get(`${carUrl}/usage/visit?${queryString}`);
};

//차량 방문 리스트
export const getCarUsageUseList = () => {
  return client.get(`${carUrl}/usage/use`);
};

//차량 예약
export const reservationUsageLog = (dataToSubmit) => {
  return client.post(
    `${carUrl}/usage/reservation/`,
    dataToSubmit,
  );
};

export const reservCancel = (id) => {
  return client.put(
    `${carUrl}/usage/reservation/${id}`,
    {}
  );
};

//차량 신청 및 내용 업데이트
export const registerUsageLog = (dataToSubmit) => {
  return client.post(
    `${carUrl}/usage/register/`,
    dataToSubmit,
  );
};

//차량 신청 취소
export const deleteCarLog = (deleteParams) => {
  return client.delete(`${carUrl}/usage/delete/`, {
    data: deleteParams
  });
};

// ✅ 차량 자산 가져오기
export const getCarAssetList = () => {
  return client.get(`${carUrl}/assets/list`);
};

// ✅ 신규 차량 자산 등록 (POST)
export const registerCarAsset = (dataToSubmit) => {
  return client.post(
    `${carUrl}/assets/register/`, 
    dataToSubmit
  );
};

// ✅ 기존 차량 자산 수정 (PUT)
export const updateCarAsset = (dataToSubmit) => {
  return client.put(
    `${carUrl}/assets/update/${dataToSubmit.carUuid}`, 
    dataToSubmit
  );
};

// ✅ 차량 자산 삭제 (DELETE) - 필요 시
export const deleteCarAsset = (id) => {
  return client.delete(`${carUrl}/assets/delete/${id}`);
};


